import { render, staticRenderFns } from "./DetailDescr.vue?vue&type=template&id=3b147375&"
import script from "./DetailDescr.vue?vue&type=script&lang=js&"
export * from "./DetailDescr.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports